import Vendor from '@adaptors-api/vendor-api';
import { IMeta } from '@interfaces/imeta';
import { IVendor } from '@interfaces/ivendor';
import { isFetchingData, setMetaData, setNotification } from '@pages/base/action';
import ActionTypes from '@store/action-types';
import { EnumLoading, DataName } from '@utils/constants';
import RequestAPI from '@utils/request-api';

const setLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.SET, DataName.VENDOR));
};
const unsetLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.REMOVE, DataName.VENDOR));
};

export const setVendor = (vendor?: IVendor) => ({
  vendor,
  type: ActionTypes.PAGE_VENDOR_SET_VENDOR,
});

export const setVendorList = (vendorList: IVendor[]) => ({
  vendorList,
  type: ActionTypes.PAGE_VENDOR_SET_VENDOR_LIST,
});

export const fetchVendor = (code: string) => (dispatch: any) => {
  setLoading(dispatch);

  if (!code) {
    dispatch(setVendor(undefined));
    unsetLoading(dispatch);
    return;
  }

  return RequestAPI(Vendor.getVendor(code))
    .then((response: any) => {
      const { data } = response.data;
      const vendor: IVendor = data;
      dispatch(setVendor(vendor));
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const fetchVendorList = (params?: any, isSetMeta: boolean = true) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vendor.getVendors(params))
    .then((response: any) => {
      const { data, meta } = response.data;
      const vendorList: IVendor[] = data;
      const metaData: IMeta = meta;
      dispatch(setVendorList(vendorList));
      if (isSetMeta) {
        dispatch(setMetaData(metaData));
      }
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const createVendor = (body: IVendor) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vendor.createVendor(body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Buat Vendor ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Buat Vendor Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};

export const updateVendor = (code: string, body: IVendor) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(Vendor.updateVendor(code, body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Ubah Vendor ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Ubah Vendor Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};
